import { render, staticRenderFns } from "./ShowFooter.vue?vue&type=template&id=7a4953ff&scoped=true&"
import script from "./ShowFooter.vue?vue&type=script&lang=js&"
export * from "./ShowFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4953ff",
  null
  
)

export default component.exports